import { Button, ButtonProps, Input, Modal, Space } from "antd";
import { useEffect, useState } from "react";
import { useCreateCoverageConfirmationTransitionMutation } from "../../redux/api/coverageConfirmationApiSlice";
import { CoverageConfirmation } from "../../types/negotiations";
import { SubmissionStates } from "./SelectSurveyPageCard";

export default function ModifySubmissionButton({ coverageConfirmation, buttonProps }: {
  coverageConfirmation: CoverageConfirmation,
  buttonProps?: ButtonProps
}) {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [currentNote, setCurrentNote] = useState<string>("");
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);

  const [createTransition] = useCreateCoverageConfirmationTransitionMutation();

  useEffect(() => {
    let disabled: boolean = false;
    if (coverageConfirmation.submission_state === SubmissionStates.QUOTATION_SENT || coverageConfirmation.submission_state === SubmissionStates.CONFIRMATION_SENT)
      disabled = true;
    setIsButtonDisabled(disabled);
  }, [coverageConfirmation.submission_state]);

  const onConfirmModal = () => {
    createTransition({ coverageConfirmationUuid: coverageConfirmation.uuid, state_cc_to: "0030", notes: currentNote });
    setCurrentNote("");
    setIsModalOpen(false);
  };

  return <>
    <Modal open={isModalOpen}
           title={"Richiedi approfondimenti Submission"}
           onCancel={() => {
             setCurrentNote("");
             setIsModalOpen(false);
           }}
           okButtonProps={{ disabled: currentNote.trim() === "" }}
           okText={"Richiedi"}
           onOk={() => onConfirmModal()}
    >
      <Space direction={"vertical"} style={{ width: "100%" }}>
        <div>
          Commento:
        </div>
        <Input.TextArea value={currentNote} onChange={e => setCurrentNote(e.target.value)} />
      </Space>
    </Modal>
    <Button
      {...buttonProps}
      style={{ width: "100%", ...buttonProps?.style }}
      disabled={isButtonDisabled || buttonProps?.disabled}
      onClick={(e) => {
        buttonProps?.onClick?.(e);
        setIsModalOpen(true);
      }}
    >
      Richiedi approfondimenti
    </Button>
  </>;
}